"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterLinkItemToJSON = exports.FooterLinkItemFromJSONTyped = exports.FooterLinkItemFromJSON = exports.instanceOfFooterLinkItem = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FooterLinkItem interface.
 */
function instanceOfFooterLinkItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFooterLinkItem = instanceOfFooterLinkItem;
function FooterLinkItemFromJSON(json) {
    return FooterLinkItemFromJSONTyped(json, false);
}
exports.FooterLinkItemFromJSON = FooterLinkItemFromJSON;
function FooterLinkItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': !(0, runtime_1.exists)(json, 'label') ? undefined : json['label'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.FooterLinkItemFromJSONTyped = FooterLinkItemFromJSONTyped;
function FooterLinkItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'url': value.url,
    };
}
exports.FooterLinkItemToJSON = FooterLinkItemToJSON;
